// extracted by mini-css-extract-plugin
export default {"navSection":"Nav_navSection__2r8si","active":"Nav_active__EXx8F"};